import * as React from "react";

import { MenuLayer } from "@hubper/core-ui/components";
import { SelectMenuItem, SelectMenu, Icon } from "@hubper/core-ui/elements";
import { useOutsideClick } from "@hubper/core-ui/hooks";
import { PoseGroup } from "react-pose";

import Field from "../components/Field";

type Props = {
  style?: React.CSSProperties;
  className?: string;
  map: Record<string, string>;
  placeholder?: string;
  onChange: (value: string) => void;
  value: string | null;
};

type Item = {
  value: string;
  display: string;
};

function String(
  { style, className, map, placeholder, onChange, value }: Props,
  ref: any
) {
  const [isOpen, setOpen] = React.useState(false);
  const mainRef = React.useRef<HTMLDivElement>(null);
  const menuRef = React.useRef<HTMLDivElement>(null);

  useOutsideClick([mainRef, menuRef], () => {
    if (isOpen) {
      setOpen(false);
    }
  });

  React.useImperativeHandle(ref, () => ({
    focus: () => {
      mainRef.current!.click();
    }
  }));

  const items: Item[] = Object.keys(map).map(x => ({
    value: x,
    // @ts-ignore
    display: map[x]
  }));

  const selectedItem = items.find(item => item.value === value);

  return (
    <>
      <Field
        data-testid="enum-filter"
        isDropDown
        ref={mainRef}
        style={style}
        className={className}
        onClick={() => setOpen(!isOpen)}
        isOpen={isOpen}
        placeholder={placeholder}
        value={selectedItem ? selectedItem.display : ""}
      >
        <Icon
          name="dropdown"
          size={16}
          c={["grey", 6]}
          style={{
            transform: `rotate(${isOpen ? 180 : 0}deg)`,
            transition: "0.2s"
          }}
        />
      </Field>
      <MenuLayer element={mainRef.current}>
        {style => (
          <PoseGroup flipMove={false}>
            {isOpen && (
              <SelectMenu key="menu" style={style} ref={menuRef}>
                {items.map(item => {
                  return (
                    <SelectMenuItem
                      onClick={() => {
                        setOpen(false);
                        onChange(item.value);
                      }}
                      key={item.value}
                      style={{ padding: "4px 12px" }}
                    >
                      {item.display}
                    </SelectMenuItem>
                  );
                })}
              </SelectMenu>
            )}
          </PoseGroup>
        )}
      </MenuLayer>
    </>
  );
}

export default React.forwardRef(String);
